import React from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import {withData} from "./containers/DataContainer";

import Theme from "./Theme"


function withRoot(Component) {
  return withData(props =>
    // MuiThemeProvider makes the theme available down the React tree
    // thanks to React context.
      <MuiThemeProvider theme={Theme(props.data.theme)}>
        <CssBaseline />
        <Component {...props} />
      </MuiThemeProvider>
  );
}

export default withRoot;
